<template>
    <b-card class="info-card">
        <template v-slot:header>
                <i v-bind:key=icon v-for="icon in icons" class="fas" :class=icon></i>
        </template >
        <b-card-body class="h-100 d-flex flex-column">
            <h3>{{title}}</h3>
            <b-card-text><slot/></b-card-text>
            <b-button v-if=!hideButton class="align-self-center card-button" href="mailto:opmbyjerry@proximus.be" variant="dark">Afspraak maken</b-button>
        </b-card-body>
    </b-card>
</template>


<script>
    export default {
        name: 'Card',
        props: {
            title: String,
            image: String,
            icons: Array,
            hideButton: Boolean
        }
    }
</script>

<style>
    .card-button{
        margin-top: auto;
    }
    /*.card.info-card{
        border-color: gray;
        border-style: solid;
        border-width: 2px 0px 2px 0px;
    }*/
    .info-card .card-header{
        border-radius: 0px;
    }
    .info-card i{
        margin-left: 12px;
        margin-right: 12px;
        font-size: 60px;
    }
</style>